import React from "react";

const Button = ({
  children,
  variant = "primary",
  onClick,
  type = "button",
  className = "",
  size = "default",
  disabled = false,
}) => {
  const baseStyles =
    "font-semibold rounded-xl transition-all duration-300 inline-block text-center cursor-pointer font-sans focus:outline-none focus:ring-4 focus:ring-primary-500/50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100";

  const sizes = {
    small: "py-2 px-5 text-sm",
    default: "py-3 px-8 text-base",
    large: "py-4 px-10 text-lg",
  };

  const variants = {
    primary:
      "bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white shadow-md hover:shadow-primary-glow hover:scale-105 active:scale-100",
    secondary:
      "bg-white hover:bg-gray-50 text-primary-600 border-2 border-primary-600 hover:border-primary-700 hover:text-primary-700 hover:shadow-md hover:scale-105 active:scale-100",
    outline:
      "bg-transparent hover:bg-primary-50 text-primary-600 border border-primary-600 hover:border-primary-700 hover:shadow-sm",
    ghost: "bg-white/20 hover:bg-white/30 text-white backdrop-blur-md border border-white/30 hover:border-white/50",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${sizes[size]} ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
